import { render, staticRenderFns } from "./AddScript.vue?vue&type=template&id=dce640be&scoped=true&"
import script from "./AddScript.vue?vue&type=script&lang=js&"
export * from "./AddScript.vue?vue&type=script&lang=js&"
import style0 from "./AddScript.vue?vue&type=style&index=0&id=dce640be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce640be",
  null
  
)

export default component.exports